export enum AddressFormTab {
  GeneralInfo = 'generalInfo',
  InteractiveMap = 'interactiveMap',
  PostalInfo = 'postalInfo',
  LocationInfo = 'locationInfo',
  CadastralInfo = 'cadastralInfo',
}
